// extracted by mini-css-extract-plugin
export default {"PageTitle":"L5ViSrtu","PageButton":"FKLJieMx"};